import React from 'react';
import PropTypes from 'prop-types';

export default class Jumbotron extends React.PureComponent {
  render() {
    const {
      isLoading,
      variant,
      title,
      text,
    } = this.props;

    return (
      <div className={`Jumbotron ${
        isLoading ? 'Jumbotron--loading' : ''
      } ${
        variant ? `Jumbotron--${variant}` : ''
      }`}
      >
        <div>
          <h1
            className="Jumbotron__title"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: title }}
          />
          {text && (
            <p
              className="Jumbotron__text"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
        </div>
      </div>
    );
  }
}

Jumbotron.propTypes = {
  isLoading: PropTypes.bool,
  variant: PropTypes.string,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

Jumbotron.defaultProps = {
  isLoading: false,
  variant: '',
};
